var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowTankVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Global / Icons / Notifications / Low Tank Volume") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global-/-Icons-/-Notifications-/-Low-Tank-Volume",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF7756",
    x: 0,
    y: 0,
    width: 34,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0527182,5.24477568 C18.4617513,5.44684324 18.7956895,5.76178541 19.0099449,6.14755076 L27.7404605,21.8667801 C28.3219884,22.9138168 27.8934234,24.2072126 26.7832338,24.7556604 C26.4583441,24.91616 26.0970467,25 25.7302844,25 L8.26925328,25 C7.0159793,25 6,24.0418145 6,22.8598327 C6,22.5139336 6.08889689,22.1731884 6.25907716,21.8667801 L14.9895927,6.14755076 C15.5711206,5.10051404 16.9425286,4.69632787 18.0527182,5.24477568 Z M16.5136948,8.18253281 C16.3509736,8.27309494 16.2167731,8.40729539 16.126211,8.57001664 L8.92243772,21.5136948 C8.65385877,21.9962752 8.82734119,22.6052101 9.30992154,22.873789 C9.45864126,22.9565586 9.62602579,23 9.79622674,23 L24.2037733,23 C24.756058,23 25.2037733,22.5522847 25.2037733,22 C25.2037733,21.8297991 25.1603319,21.6624145 25.0775623,21.5136948 L17.873789,8.57001664 C17.6052101,8.08743629 16.9962752,7.91395387 16.5136948,8.18253281 Z M17,19 C17.552,19 18,19.448 18,20 C18,20.552 17.552,21 17,21 C16.448,21 16,20.552 16,20 C16,19.448 16.448,19 17,19 Z M17,11 C17.552,11 18,11.448 18,12 L18,17 C18,17.552 17.552,18 17,18 C16.448,18 16,17.552 16,17 L16,12 C16,11.448 16.448,11 17,11 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowTankVolume);
export default __webpack_public_path__ + "static/media/low-tank-volume.f770946b.svg";
export { ForwardRef as ReactComponent };